angular.module('main').directive('modalHello', [
	function() {
		return {
			restrict: 'E',
			template() {
				let templateHtml = '';
				templateHtml +=
					'<div id="helloModal" class="modal modal-center fade" tabindex="-1" role="dialog" data-keyboard="false" data-autotest-modal="helloModal">';
				templateHtml +=
					'    <div class="modal-dialog modal-welcome modal-confirm">';
				templateHtml += '        <div class="modal-content modal-banner">';
				templateHtml += '            <div class="ninja-logo-wrapper">';
				templateHtml +=
					'                <img src="https://app.studioninja.co/build/release-pipeline-10/resources/dist/assets/images/logo/sign-up-logo.png" alt="ninja">';
				templateHtml += '            </div>';
				templateHtml +=
					'            <h2 class="text-center mb-0 mt-30">Thanks for signing up!</h2>';
				templateHtml += '            <div class="modal-body">';
				templateHtml +=
					'                <p class="mb-30">Please check your email and click on the confirmation link in the message. Check your spam folder as well if you can\'t find it in your inbox.</p>';
				templateHtml +=
					"                <p>Once your account is activated, we'll send you a series of emails to help you get started with Studio Ninja.</p>";
				templateHtml += '            </div>';
				templateHtml += '            <div class="modal-footer modal-foot">';
				templateHtml +=
					'                <button class="btn btn-grey-light btn-lg" type="button" data-dismiss="modal" aria-hidden="true">Close</button>';
				templateHtml += '            </div>';
				templateHtml += '        </div>';
				templateHtml += '    </div>';
				templateHtml += '</div>';

				return templateHtml;
			},
			scope: {},
			replace: true,
			transclude: true
		};
	}
]);



// WEBPACK FOOTER //
// ./web/js/components/Modals/public/modalHello.js